module.exports = __webpack_public_path__ + "static/media/transfer_notification.191725d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/transfer_notification.mp3
// module id = tasy
// module chunks = 11